import { LS, utmKeys } from "./constants";
import { safeSet, safeGet, genFallbackId, isCampaignMode } from "./helpers";

// 1) Persist campaign params + click ids on first landing (call on every page load)

(function persistCampaignParamsFromUrl() {
  try {
    if (isCampaignMode().isCampaignMode) {
      // UTM and known click-id keys
      utmKeys.forEach((k) => {
        const v = isCampaignMode().params.get(k);
        if (v) safeSet(k, v);
      });
      // persist first touch timestamp and stable attrib id if not present
      if (!safeGet(LS.FIRST_TOUCH_TS)) safeSet(LS.FIRST_TOUCH_TS, Date.now());
      if (!safeGet(LS.ATTR_ID)) safeSet(LS.ATTR_ID, genFallbackId("ao"));
      // optional: store raw _ga cookie value for session joins
      const gaCookie = document.cookie
        .split("; ")
        .find((r) => r.trim().startsWith("_ga="));
      if (gaCookie) safeSet(LS.GA_CLIENT_ID, gaCookie.split("=")[1]);
    }
  } catch (e) {
    /* noop */
  }
})();
